module.exports = __webpack_public_path__ + "img/Vimkey-macOS-store-f.d5189ae7.png";